import React from "react";
import { useLang } from "../context/LangContext";
import { Link } from "react-router-dom";
import { CheckCircle, Lightning, Waveform } from "@phosphor-icons/react";
import { t } from "../lib/i18n";

export default function About() {
  const { lang } = useLang();
  return (
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20" data-testid="about-page">
      <div className="grid lg:grid-cols-2 gap-16 items-start">
        <div>
          <div className="label-tag mb-4 slash">{t("sections.about_eyebrow", lang)}</div>
          <h1 className="display-font text-5xl sm:text-7xl font-black uppercase tracking-tighter leading-[0.9]">
            {lang === "gr" ? <>Φτιαγμένοι στο<br/><span className="neon-text">σκοτάδι.</span></> : <>Built in the<br/><span className="neon-text">dark.</span></>}
          </h1>
          <p className="text-gray-300 mt-8 text-lg leading-relaxed">
            {lang === "gr"
              ? "Από το 2002 η MP Sound (A.A. Model Power Ltd) σχεδιάζει, εγκαθιστά και υποστηρίζει επαγγελματικά συστήματα ήχου και φωτισμού σε όλη την Κύπρο. Από underground clubs μέχρι open-air festivals — δίνουμε στις νύχτες σας ένταση."
              : "Since 2002, MP Sound (A.A. Model Power Ltd) has designed, installed and supported pro audio and lighting rigs across Cyprus. From underground clubs to open-air festivals — we give your nights their bite."}
          </p>
          <p className="text-gray-400 mt-6">
            {lang === "gr"
              ? "Η ομάδα μας αποτελείται από μηχανικούς ήχου, σχεδιαστές φωτισμού, τεχνικούς service και crew — όλοι με πραγματική εμπειρία στο πεδίο. Δουλεύουμε με κορυφαίες μάρκες και πρότυπα ασφαλείας."
              : "Our team is made of touring engineers, lighting designers, service technicians and crew — all with real road experience. We work with flagship brands and rig to industry safety standards."}
          </p>

          <div className="grid sm:grid-cols-2 gap-4 mt-10">
            {[
              { en: "Certified rigging crew", gr: "Πιστοποιημένο rigging crew" },
              { en: "Amate Audio official partner", gr: "Επίσημος συνεργάτης Amate Audio" },
              { en: "On-site service guarantee", gr: "Εγγύηση service επί τόπου" },
              { en: "Bilingual project managers", gr: "Δίγλωσσοι project managers" },
            ].map((x, i) => (
              <div key={i} className="flex items-start gap-3" data-testid={`about-bullet-${i}`}>
                <CheckCircle size={20} weight="fill" className="text-[#ccff00] mt-0.5" />
                <span className="text-gray-200">{(x[lang] || x.en)}</span>
              </div>
            ))}
          </div>

          <Link to="/contact" className="btn-primary mt-10">{t("cta.send", lang)}</Link>
        </div>

        <div className="relative">
          <img
            src="https://static.prod-images.emergentagent.com/jobs/50590957-5819-4a6e-b3ee-9ef342eeb207/images/78dd00b98cdfd2c16fca917c38b78209c2ff4599ae9a4dc330882b4d5d15bbfe.png"
            alt="Engineer in nightclub" className="w-full object-cover aspect-[4/5]" />
          <div className="absolute -bottom-6 -left-6 card-dark p-6 max-w-xs">
            <Lightning size={24} weight="duotone" className="text-[#ccff00] mb-2" />
            <div className="display-font text-xl font-bold leading-tight">
              {lang === "gr" ? "Πραγματική ισχύς. Πραγματικός ήχος." : "Real power. Real sound."}
            </div>
          </div>
        </div>
      </div>

      {/* Mission strip */}
      <div className="mt-24 grid md:grid-cols-3 gap-6">
        {[
          { h: { en: "Our mission", gr: "Η αποστολή μας" }, p: { en: "Make every show, club and venue in Cyprus sound and look world-class.", gr: "Κάθε χώρος στην Κύπρο να ηχεί και να φαίνεται παγκόσμιας κλάσης." } },
          { h: { en: "Our process", gr: "Η διαδικασία" }, p: { en: "Listen → design → prototype → tune → support. Every project. Every time.", gr: "Ακούμε → σχεδιάζουμε → προσομοίωση → tune → υποστήριξη." } },
          { h: { en: "Our promise", gr: "Η υπόσχεση μας" }, p: { en: "If something can fail on show-day, we've already built a redundancy for it.", gr: "Αν κάτι μπορεί να αποτύχει στην παράσταση, έχουμε ήδη backup." } },
        ].map((c, i) => (
          <div key={i} className="card-dark p-7" data-testid={`mission-card-${i}`}>
            <Waveform size={28} weight="duotone" className="text-[#00f0ff] mb-4" />
            <div className="display-font text-xl font-bold">{c.h[lang] || c.h.en}</div>
            <p className="text-gray-400 mt-3 text-sm">{c.p[lang] || c.p.en}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
